import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import Select from "react-select";
import axios from "axios";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Sidebar from "./Sidebar";
import { apiUrl, uniqueID, innerbanner } from "../Settings/Config";
import { hideLoader, showLoader } from "../Settings/SettingHelper";

class Myaccount extends Component {
  constructor(props) {
    super(props);
    const customerID = localStorage.getItem("customerID") ?? "";
    this.state = {
      trigerCart: false,
      loginPopup: false,
      customerID: customerID,
      customerFirstName: "",
      customerLastName: "",
      customerEmail: "",
      customerPhone: "",
      customerBirthDate: "",
      customerGender: "",
      loginopenPopup: false,
      enableAscentisCRM: false,
      ascentisMemberID:"",
      cardNumber:"",
      expiryDate:"",
      globalSettings: "",
    };
  }

  componentDidMount() {
    if (this.state.customerID === "") {
      cookie.save("triggerLogin", "Yes", { path: "/" });
      this.props.history.push("/");
    } else {
      /* const verifyOTP = localStorage.getItem("verifyOTP") ?? "";
      if(verifyOTP==="") {
        cookie.save('tiggerOTP', 'Yes', { path: "/" })
        this.props.history.push("/");
      }else { */
        this.loadCustomerDetails();
      /* }  */     
    }
  }
  componentWillReceiveProps(PropsDt) {
    if (this.state.globalSettings !== PropsDt.globalSettings) {
      this.setState({
        globalSettings: PropsDt.globalSettings,
        enableAscentisCRM: true,
      });
    }
  }
  loadCustomerDetails() {
    axios
      .get(
        `${apiUrl}customer/details?uniqueID=${uniqueID}&customerID=${this.state.customerID}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
      )
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          const customerBirthDate = result?.customerBirthDate ?? "";
          const customerGender = result?.customerGender ?? "";
          const customerName = result?.customerName ?? "";
          const customerFirstName = result?.customerFirstName ?? "";

          this.setState({
            customerFirstName:
              customerFirstName !== "" ? customerFirstName : customerName,
            customerLastName: result?.customerLastName ?? "",
            customerEmail: result?.customerEmail ?? "",
            customerPhone: result?.customerPhone ?? "",
            customerBirthDate:
              customerBirthDate !== "" && customerBirthDate !== null
                ? new Date(customerBirthDate)
                : "",
            customerGender:
              customerGender !== "" && customerGender !== null
                ? { label: customerGender, value: customerGender }
                : "",
            ascentisMemberID:result?.ascentisMemberID ?? "",
            cardNumber:result?.cardNumber ?? "",
            expiryDate:result?.expiryDate ?? "",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange(name, e) {
    const value = name === "customerBirthDate" ? e : e.target.value;
    if (name === "mobile") {
      const value_ = value.replace(/[^0-9]/g, "");
      this.setState({ [name]: value_, [`${name}Error`]: "" });
    } else {
      this.setState({ [name]: value, [`${name}Error`]: "" });
    }
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  saveData() {
    showLoader("updateprofile");
    const postObject = {
      uniqueID,
      customerFirstName: this.state.customerFirstName,
      customerLastName: this.state.customerLastName,
      customerPhone: this.state.customerPhone,
      customerBirthDate: this.state.customerBirthDate,
      customerGender: this.state.customerGender?.value ?? "",
    };
    axios
      .put(
        `${apiUrl}customer/updatedetail/${this.state.customerID}`,
        postObject
      )
      .then((res) => {
        hideLoader("updateprofile");
        if (res.data.status === "ok") {
          toast.success("Profile Update Successfully.");
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(errorMsg);
        hideLoader("updateprofile");
        console.error("Error fetching data:", e);
      });
  }

  updateStateValue = (field, value) => {
    this.setState({ [field]: value });
  };

  callheaderFunction = () => {
    this.setState({ loginopenPopup: true });
  };

  render() {
    return (
      <div className="cover">
        <Header
          trigerCart={this.state.trigerCart}
          updateStateValue={this.updateStateValue.bind(this)}
          loginPopup={this.state.loginPopup}
          loginopenPopup={this.state.loginopenPopup}
        />
        <div className="inner-banner">
          <img src={innerbanner} alt="banner" />
          <div className="inner-caption">My Profile</div>
        </div>
        <div className="innerpage myaccount-pages">
          <div className="container">
            <div className="dashboard-main">
              <Sidebar {...this.props} active="myprofile" />
              <div className="dashboard-aside">
                {/* Order  Start  */}
                <div className="da-acc-info">
                  <div>
                  <div className="account-split">
                    <h4>Account Information</h4>
                    {this.state.enableAscentisCRM && this.state.ascentisMemberID==="" && (
                      <button
                        className="button"
                        onClick={this.callheaderFunction}
                      >
                        Upgrade Member
                      </button>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="control-label">First Name</label>
                    <div className="controls">
                      <input
                        type="text"
                        placeholder="First Name"
                        className="form-control"
                        value={this.state.customerFirstName}
                        onChange={this.handleChange.bind(
                          this,
                          "customerFirstName"
                        )}
                        readOnly={this.state.ascentisMemberID!==""?true:false}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label">Last Name</label>
                    <div className="controls">
                      <input
                        type="text"
                        placeholder="Last Name"
                        className="form-control"
                        value={this.state.customerLastName}
                        onChange={this.handleChange.bind(
                          this,
                          "customerLastName"
                        )}
                        readOnly={this.state.ascentisMemberID!==""?true:false}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label">Email Address</label>
                    <div className="controls">
                      <input
                        type="text"
                        placeholder="Email Address"
                        className="form-control"
                        readOnly={true}
                        value={this.state.customerEmail}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label">Mobile Number</label>
                    <div className="controls">
                      <input
                        type="text"
                        placeholder="Mobile Number"
                        className="form-control"
                        value={this.state.customerPhone}
                        maxLength={8}
                        onChange={this.handleChange.bind(this, "customerPhone")}
                        readOnly={this.state.ascentisMemberID!==""?true:false}
                      />
                    </div>
                  </div>

                  <div className="two-column-form">
                    <div className="form-group">
                      <label className="control-label">Birthday</label>
                      <div className="controls">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          maxDate={new Date()}
                          selected={this.state.customerBirthDate}
                          dateFormat="d-MM-yyyy"
                          placeholderText="Date Of Birth"
                          onChange={this.handleChange.bind(
                            this,
                            "customerBirthDate"
                          )}
                          readOnly={this.state.ascentisMemberID!==""?true:false}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="control-label">Gender</label>
                      <div className="controls">
                        <Select
                          value={this.state.customerGender}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "customerGender"
                          )}
                          placeholder="Select Gender"
                          isClearable={true}
                          options={[
                            {
                              label: "Male",
                              value: "Male",
                            },
                            {
                              label: "Female",
                              value: "Female",
                            },
                            {
                              label: "Transgender",
                              value: "Transgender",
                            },
                          ]}
                          isDisabled={this.state.ascentisMemberID!==""?true:false}
                        />
                      </div>
                    </div>
                  </div>
                  {this.state.ascentisMemberID==="" &&
                  <div className="single-center-btn">
                    <button
                      className="button"
                      id="updateprofile"
                      onClick={this.saveData.bind(this)}
                    >
                      Update
                    </button>
                  </div>
                  }
                  </div>
                  {this.state.ascentisMemberID!=="" &&
                   <div class="address-info-div acentismember-info-div">
                  <h4 class="form_grouptt">Member Info</h4>
                  <div class="form-group">
                    <div class="row">Member Id : {this.state.ascentisMemberID}</div>
                    <div class="row">Card No :  {this.state.cardNumber}</div>
                    <div class="row">Expiry date :  {this.state.expiryDate}</div>
                  </div>
                </div>
  }
                </div>

               
                {/* Order  End */}
              </div>
            </div>
          </div>
        </div>
        <Footer
          {...this.props}
          updateStateValue={this.updateStateValue.bind(this)}
        />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var globalSettings = "";
  if (Object.keys(state.settings).length > 0) {
    if (state.settings[0].status === "ok") {
      globalSettings = state.settings[0].result;
    }
  }
  return {
    globalSettings: globalSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(withRouter(Myaccount));
